// extracted by mini-css-extract-plugin
module.exports = {"subtitle-wrapper":"LocationAndTime--subtitle-wrapper--2cGLk","subtitleWrapper":"LocationAndTime--subtitle-wrapper--2cGLk","location":"LocationAndTime--location--22nOH"};